import { graphql } from '@/generated/gql';

export const NEGOTIATION_CONTACT_QUERY = graphql(/* GraphQL */ `
  query NegotiationContact($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        status
        processStatus
        supplier {
          id
          internalId
          name
          externalReference
          location {
            id
            internalId
            address
            city
            postalCode
            countryCode
          }
          contact {
            id
            internalId
            firstName
            lastName
            email
            language
            mobile
            phone
          }
        }
      }
    }
  }
`);
